import React, { ComponentType, useState, useContext, useEffect } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { edmCampaign } from '@bingads-webui/edm-campaign';

import { AssetContainer, IScopeContext } from '../utils/types';
import { AssetPerformanceFilterProps } from './types';
import { MAX_ASSET_CONTAINERS_IN_FILTER } from './const';

export const select = [
  'Id',
  'Status',
  'Name',
  'DeliveryStatus',
  'DeliveryStatusDetails',
];

export function useAssetGroupsData() {
  const { scope } = useContext(ScopeContext) as IScopeContext;
  const {
    values: {
      cid,
      aid,
      campaignId,
    },
  } = scope;

  const [assetContainers, setAssetContainers] = useState<AssetContainer[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Campaigns.$withKey(campaignId)
      .AssetGroups['Default.GridData']
      .$makeCall({
        query: {
          count: true,
          select,
          skip: 0,
          top: MAX_ASSET_CONTAINERS_IN_FILTER + 1,
        },
      })
      .subscribe({
        next: (assetGroups) => {
          setAssetContainers(assetGroups?.value);
          setIsLoading(false);
        },
      });
  }, [cid, aid, campaignId]);

  return { isLoading, assetContainers };
}


export function withAssetGroupsData<P extends AssetPerformanceFilterProps>(WrappedComponent: ComponentType<P>): ComponentType<Omit<P, 'assetContainer' | 'isLoading'>> {
  return (props) => {
    const { assetContainers, isLoading } = useAssetGroupsData();
    return (
      <WrappedComponent
        isLoading={isLoading}
        assetContainers={assetContainers}
        {...props as any}
      />
    );
  };
}
